// extracted by mini-css-extract-plugin
export var button = "_ms-0";
export var donut = "_ms-1";
export var donutFill = "_ms-3";
export var donutTrack = "_ms-2";